import React, {Component} from 'react';
import {connect} from 'react-redux';

import {
    Col,
    Container,
    Row
} from 'reactstrap';

import logo from '../../assets/svg/logo.svg';
import {setFooterVisibility, setNavbarVisibility} from "../navigation/actions/navbar";

class AuthContainer extends Component {

    componentWillMount() {
        document.body.classList.toggle('dark-background', true);
        this.props._setNavbarVisibility(false);
        this.props._setFooterVisibility(false);
    }

    componentWillUnmount() {
        document.body.classList.remove('dark-background');
    }

    render() {
        return (
            <div>
                <Container>
                    <Row style={{marginBottom: '2em'}} className="justify-content-md-center">
                        <Col lg="6" sm="6">
                            <div style={{textAlign: 'center'}}>
                                <img className="login-logo" width="80%" style={{maxWidth: '280px'}} src={logo}
                                     alt="PolyRents"/>
                            </div>
                            {this.props.children}
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
    _setNavbarVisibility(visible) {
        return dispatch(setNavbarVisibility(visible));
    },
    _setFooterVisibility(visible) {
        return dispatch(setFooterVisibility(visible));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(AuthContainer);


// WEBPACK FOOTER //
// ./src/containers/authentication/AuthContainer.js